import React from 'react';
import moment from 'moment';
import TruncatedText from '../../../../components/common/TruncatedText';
import {useDispatch} from 'react-redux';
import {setSuppressDateIndicator} from '../../../../redux/slices/timeline';

export interface Milestone {
  id: number;
  name: string;
  color: string;
  start_date: string;
}

interface MilestoneFlagProps {
  milestone: Milestone;
  position: { left?: string; right?: string; top: string };
}

const addAlphaToColor = (color: string, alpha: number = 0.9): string => {
  if (color.startsWith('#')) {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  
  if (color.startsWith('rgb')) {
    if (color.startsWith('rgba')) {
      return color.replace(/[\d\.]+\)$/g, `${alpha})`);
    } else {
      return color.replace('rgb(', 'rgba(').replace(')', `, ${alpha})`);
    }
  }
  
  return color;
};

export const MilestoneFlag: React.FC<MilestoneFlagProps> = ({
  milestone,
  position,
}) => {
  const dispatch = useDispatch();
  const milestoneDate = moment(milestone.start_date).format('ddd, MMM DD, YYYY');

  return (
    <div
      className="absolute !cursor-default"
      style={{
        width: 1,
        left: position.left,
        height: '100%',
        backgroundColor: milestone.color,
      }}
      onMouseEnter={() => dispatch(setSuppressDateIndicator(true))}
      onMouseLeave={() => dispatch(setSuppressDateIndicator(false))}
    >
      <div
        className="sticky"
        style={{
          top: position.top,
        }}
      >
        <TruncatedText
          text={milestone.name}
          tooltipTitle={`${milestone.name} (${milestoneDate})`}
          className='absolute text-xs border text-black/80 dark:text-white/80 min-h-6 flex items-center px-2 py-0.5 whitespace-nowrap overflow-hidden text-ellipsis rounded-r'
          style={{
            backgroundColor: addAlphaToColor(milestone.color, 0.15),
            borderColor: milestone.color,
          }}
          placement="bottom-start"
          as="span"
        />
      </div>
    </div>
  );
}; 